import { useObserver } from "mobx-react"
import * as React from "react"

import TabBar from "~/components/molecules/TabBar"
import { internalLink } from "~/services/helper"
import { useStores } from "~/stores/StoreProvider"

interface Props {
  selectedTabIndex?: number
}

const ObservedTabBar = ({ selectedTabIndex }: Props) => {
  const { userStore } = useStores()
  return (
    <>
      {useObserver(
        () =>
          userStore.authedAsStudent && (
            <TabBar
              items={[
                {
                  name: "探す",
                  icon: "Search",
                  href: `${process.env.INFRA_INTERN_URL}/long-internship`,
                },
                {
                  name: "お気に入り",
                  icon: "FavoriteStroke",
                  href: `${process.env.INFRA_INTERN_URL}/my-page/favorites`,
                },
                {
                  name: "応募管理",
                  icon: "Apply",
                  href: `${process.env.INFRA_INTERN_URL}/my-page`,
                },
                {
                  name: "スカウト管理",
                  icon: "Light",
                  href: `${process.env.INFRA_INTERN_URL}/my-page/scouts`,
                },
                {
                  name: "メッセージ",
                  icon: "Message",
                  href: `${process.env.INFRA_INTERN_URL}/my-page/messages`,
                  notificationCount: userStore.user?.unreadMessageCount,
                },
                {
                  name: "プロフィール",
                  icon: "User",
                  href: internalLink("/profile"),
                },
              ]}
              selectedTabIndex={selectedTabIndex}
            />
          )
      )}
    </>
  )
}

export default ObservedTabBar
